export const sanityApi = {
    "projectId": "m9zku83l",
    "dataset": "production"
}